var map = {
	"./beautify.json": 290,
	"./conservation-forever.json": 400,
	"./diconsa.json": 412,
	"./electro-light.json": 72,
	"./globapharm.json": 926,
	"./national-education.json": 946,
	"./shops-corporation.json": 923,
	"./talbot-trucks.json": 148
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 637;
module.exports = webpackAsyncContext;